module.exports = __webpack_public_path__ + "static/media/netflixSmall.d293e8a6.gif";